import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { HomeApi, type HomePageType } from '../../apis/home-api';
import type { HomeService } from '../home-service';

@injectable()
export class HomeServiceImpl implements HomeService {
  private homepageType: HomePageType | null = null;

  // eslint-disable-next-line no-useless-constructor
  constructor(@inject(HomeApi) private homeApi: HomeApi) {}

  async getHomePageType(): Promise<{ homepage_type: HomePageType }> {
    if (!this.homepageType) {
      this.homepageType = (await this.homeApi.getHomePageType()).homepage_type;
    }
    return { homepage_type: this.homepageType || 'RD' };
  }

  changeHomePage(home_page_type: HomePageType): Promise<boolean> {
    this.homepageType = home_page_type;
    return this.homeApi.changeHomePage(home_page_type);
  }
}
